import { AxiosError } from 'axios';
import { useState } from 'react';

import { ApiKeysInterface } from '../../../models/dashboard/configuration/api-key.model';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { apiKeysDataActions } from '../../../redux/slices/apiKeysDataSlice';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';

const useGetExistingApiKeys = () => {
  const request = useHttps();
  const dispatch = useAppDisPatch();
  const [loading, setLoading] = useState(false);

  const onGetExistingApiKeysError = (err: AxiosError<ErrorHttpResponse>) => {
    console.error(err?.response?.data?.message ?? 'Something went wrong');
  };

  const onGetExistingApiKeysSuccess = (isTestMode: boolean) => ({
    data,
  }: SuccessHttpResponse<ApiKeysInterface[]>) => {
    const targetEnvironment = isTestMode ? 'Test' : 'Live';
    const dataOfInterest = data?.find(
      (item) => item.environment === targetEnvironment,
    );

    if (dataOfInterest) {
      dispatch(apiKeysDataActions.setApiKeysData(dataOfInterest));
    }
  };

  const getExistingApiKeys = async (isTestMode: boolean) => {
    const url: HttpConfig = {
      url: `api/v1/api-key/get-key-info`,
      method: 'get',
    };

    return request(url, onGetExistingApiKeysSuccess(isTestMode), setLoading, onGetExistingApiKeysError);
  };

  return { getExistingApiKeys, loading };
};

export default useGetExistingApiKeys;
